import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../../services/current.service';
import { DatasService } from '../../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-storage-legs',
  templateUrl: './legs.component.html',
})
export class StorageLegsComponent implements OnInit {
  legs: any[];

  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    private readonly gtm: GTM,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) {}

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/pieds`, 'Rangements | Choix', {
      stepNumber: 5,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });

    this.legs = this.datas.storageInspiration.getLegs(
      this.current.storage.inspirationId,
      this.current.storage.boxId,
      this.current.storage.frontId,
      this.current.storage.handlesId
    );

    if (this.legs.length === 1) {
      this.selectLegs(this.legs[0].id);
    }
  }

  selectLegs(legsId: number) {
    if (this.current.storage.legsId !== legsId) {
      this.current.storage.legsId = legsId;
    }

    this.onComplete.emit();
  }
}
